module.exports = __webpack_public_path__ + "img/1 (125).54147558.png";